<template lang="pug">
    inline-svg.m-auto(
        :src="ICONS.bin" 
        @click="() => { if (deleteFilter) {onDeleteConfirmation(item)} }"
        :fill-opacity="deleteFilter ? 1 : 0.25"
        :class="{'cursor-pointer': deleteFilter}"
    )
</template>

<script>
//Components
import SwitcherStyleOne from '@/components/common/switchers/style-1';
//Configs
import { ICONS } from '@/configs/icons';
//Store
import { RootGetterTypes } from '@/store/types';
/* eslint-disable no-unused-vars */
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';
import { FilesNameSpace, FilesActionTypes } from '@/store/files/types';
//Mixins
import { deleteConfirmation, closeModalDialog } from '@/mixins/modals';

export default {
    name: "DeleteComponent",
    mixins: [deleteConfirmation, closeModalDialog],
    components: {
       'switcher': SwitcherStyleOne, 
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        context: {
            type: Object,
            default: () => ({
                name_space: 'users',
                action: 'DeleteUser',
            }),
        }
    },
    computed: {
        ICONS() {
            return ICONS
        },
        deleteFilter() {
            return this.$store.getters[`${RootGetterTypes.GetDeleteFilterStatus}`]
        },
    },
    methods: {
        async onDeleteConfirmation() {
            this.deleteConfirmation({ confirm: 'onDelete' })
            
        },
        async onDelete() {
            await this.$store.dispatch(`${this.context.name_space}/${this.context.action}`, { id: this.item._id }) 
            this.closeModalDialog()
        },
    }
}
</script>